import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { GridApi } from 'ag-grid-community';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { DatePickerGlobalOptions, serviceConstants } from 'src/app/constants/service.constants';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { CommonService } from '../../../../services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';
import { Publications } from 'src/app/models/um/organization';

@Component({
  selector: 'app-ist-publications-view-modal',
  templateUrl: './ist-publications-view-modal.component.html',
  styleUrls: ['./ist-publications-view-modal.component.scss']
})
export class IstPublicationsViewModalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  publicationsForm: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  appstatus: boolean;
  formData: FormData;
  typeOptions = [];
  contentOptions = [];
  ApplicationID: any;
  columnDefs;
  gridApi: GridApi;
  rowData;
  context;
  minDate: Date = new Date();
  gridOptions;
  istPublications: Publications;
  frameworkComponents;
  loadGrid = false;
  userType: string = "";
  myDate = new Date();
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  operations: any[] = [];
  Attachments: any[] = [];
  RequiredSettings: boolean = true;
  selectedRow: any;
  StartDate: Date
  EndDate: Date
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  TempOperations: { name: string; id: string; }[];
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService
  ) { }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {

    this.getStaticFiledsData('SCR-011');
    this.rowData = [];
    this.appstatus = this.commonService.getIstStatus();

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });

    this.userType = this.userService.getUserType();
    if (this.Content.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }

    this.GetMaserDropData();
    this.publicationsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TYPE_ID: new UntypedFormControl(""),
      CONTENT_ID: new UntypedFormControl(""),
      JOURNAL_NAME: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      EXPECTED_DATE: new UntypedFormControl(null),
      ANALYSIS_END_DATE: new UntypedFormControl(null),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0),
      ANALYSIS_END_DATEO: new UntypedFormControl(null),
      EXPECTED_DATEO: new UntypedFormControl(null)

    });

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();
      this.istPublications = new Publications();
    } else if (this.Content.heading === 'View') { //View mode
      this.getRecordFprEdit();
      this.publicationsForm.disable();
    }
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ];

    this.TempOperations = [];

    this.context = { id: this.Content.content.id, componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
  }

  deleteRow() { }

  GetMaserDropData() {
    this.summaryService.getScreenDataForEdit("api/ISTPublications/GetMaserDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(result => {
      this.typeOptions = result["MasterData1"];
      this.typeOptions = [{ label: "Select", value: null, checked: true }].concat(this.typeOptions);
      this.contentOptions = result["MasterData2"];
      this.contentOptions = [{ label: "Select", value: null, checked: true }].concat(this.contentOptions);
    });

  }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTPublications/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      if (result["EXPECTED_DATE"] != null && result["EXPECTED_DATE"] != undefined) {
        //result["EXPECTED_DATE"] = this.datepipe.transform(result["EXPECTED_DATE"], 'dd-MMM-yyyy');
        //this.StartDate = new Date(this.publicationsForm.controls["EXPECTED_DATE"].value);

        this.StartDate = this.commonService.getdisplayedDate(result["EXPECTED_DATE"]);
        result["EXPECTED_DATE"] = this.StartDate;
      }
      if (result["ANALYSIS_END_DATE"] != null && result["ANALYSIS_END_DATE"] != undefined) {
        
        this.EndDate = this.commonService.getdisplayedDate(result["ANALYSIS_END_DATE"]);
        result["ANALYSIS_END_DATE"] =this.EndDate;

      }
      this.publicationsForm.patchValue({
        ID: result["ID"],
        APPLICATION_ID: result["APPLICATION_ID"],
        TYPE_ID: result["TYPE_ID"],
        CONTENT_ID: result["CONTENT_ID"],
        JOURNAL_NAME: result["JOURNAL_NAME"],
        TITLE: result["TITLE"],
        EXPECTED_DATE: result["EXPECTED_DATE"],
        ANALYSIS_END_DATE: result["ANALYSIS_END_DATE"],
        NOTES: result["NOTES"],
        STATUS: result["STATUS"],
      });



      this.rowData = result["Attachments"];
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);

      if (this.publicationsForm.controls["STATUS"].value == '2') { // Edit mode
        this.publicationsForm.disable();
        this.Content.heading = "View";
      }

      this.extendedForm.rowid = result["ID"];
      this.extendedForm.getResponse();
    });

  }

  editRow() {
  }

  SubmitRecord() {
    if (this.validateControls()) {
      // var formData = this.publicationsForm.value;
      var formData = this.getForm();
      if (formData["EXPECTED_DATE"] != null) {
        const ldate = new Date(formData["EXPECTED_DATE"]);
        formData["STR_EXPECTED_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData["EXPECTED_DATE"] = new Date(formData["EXPECTED_DATE"]);
      }
      if (formData["ANALYSIS_END_DATE"] != null) {
        const ldate = new Date(formData["ANALYSIS_END_DATE"]);
        formData["STR_ANALYSIS_END_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData["ANALYSIS_END_DATE"] = new Date(formData["ANALYSIS_END_DATE"])
      }
      formData["APPLICATION_ID"] = this.ApplicationID;
      let title = this.publicationsForm.controls["TITLE"].value;
      formData["STATUS"] = 2;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;
      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTPublications/Insert", formData).subscribe(result => {
          if (result.Status == 0) {
            this.publicationsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result.Status == 0) {
                this.commonService.SuccessBanner("Publication " + title + " Added/Submitted successfully");
                this.modalRef.close();
              }
              else{
                this.commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/ISTPublications/Update", formData).subscribe(result => {
          if (result.Status == 0)
          {
            this.publicationsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS")
              {
               if (result.Status == 0)
               {
                this.commonService.SuccessBanner("Publication " + title + " submitted successfully");
                this.modalRef.close();
               }
               else{
                 this.commonService.ValidationBanner(result.Message);
               }
             }
             else{
              if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                this.commonService.ValidationBanner(result.Message);
              }
              else {
                this.commonService.SuccessBanner("Publication " + title + " submitted successfully");
                this.modalRef.close(formData);
              }
             }


            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }

          // if (result.Status == 0) {
          //   this.publicationsForm.controls["ID"].setValue(result.TransactionID);
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     this.commonService.SuccessBanner("Publication " + title + " submitted successfully");

          //     this.modalRef.close();
          //   });
          // } else {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
          //       this.commonService.ValidationBanner(result.Message);
          //     }
          //     else {
          //       this.commonService.SuccessBanner("Publication " + title + " submitted successfully");
          //       //  this.action.next(formData);
          //       this.modalRef.close(formData);
          //     }
          //   });
          // }

        });
      }
    }
  }

  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    debugger
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  GetStartDate(): DateObject {
    //let lDate = this.milestoneForm.controls['STUDY_START_DATE'].value;
    var formModel = this.publicationsForm.getRawValue();
    const lDate = new Date(formModel.EXPECTED_DATE);
    //let lDate = new Date(this.milestoneForm['STUDY_START_DATE'])
    if ((this.CompareDates(this.StartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) && formModel.EXPECTED_DATE != null) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }

    return this.Full_Start_Date
  }

  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {

      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }


  GetEndDate(): DateObject {
    const formModel = this.publicationsForm.getRawValue();
    const lDate = new Date(formModel.ANALYSIS_END_DATE);
    if ((this.CompareDates(this.EndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.ANALYSIS_END_DATE != null)
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
      else {
        this.Full_End_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: true,
          HasValue: true,
          IsDateModified: true
        }
      }
    return this.Full_End_Date;
  }

  private getForm(): Publications {
    const formModel = this.publicationsForm.getRawValue();
    let obj = new Publications();
    obj = {
      ID: formModel.ID,
      APPLICATION_ID: formModel.APPLICATION_ID || '',
      TYPE_ID: formModel.TYPE_ID || '',
      CONTENT_ID: formModel.CONTENT_ID || '',
      JOURNAL_NAME: formModel.JOURNAL_NAME || '',
      TITLE: formModel.TITLE || '',
      EXPECTED_DATE: formModel.EXPECTED_DATE || null,
      ANALYSIS_END_DATE: formModel.ANALYSIS_END_DATE || null,
      NOTES: formModel.NOTES || null,
      STATUS: formModel.STATUS || 0,
      ANALYSIS_END_DATEO: formModel.ANALYSIS_END_DATEO || null,
      EXPECTED_DATEO: formModel.EXPECTED_DATEO || null
    };
    if (this.Content.heading != "Add") {
      this.istPublications.ID = obj.ID;
      this.istPublications.APPLICATION_ID = obj.APPLICATION_ID;
      this.istPublications.TYPE_ID = obj.TYPE_ID
      this.istPublications.JOURNAL_NAME = obj.JOURNAL_NAME;
      this.istPublications.CONTENT_ID = obj.CONTENT_ID;
      this.istPublications.NOTES = obj.NOTES;
      this.istPublications.TITLE = obj.TITLE;
      this.istPublications.STATUS = obj.STATUS;
      this.istPublications.EXPECTED_DATE = obj.EXPECTED_DATE;
      const sdate = this.GetStartDate();
      this.istPublications.EXPECTED_DATEO = sdate;
      this.istPublications.ANALYSIS_END_DATE = obj.ANALYSIS_END_DATE;
      const edate = this.GetEndDate();
      this.istPublications.ANALYSIS_END_DATEO = edate;
      return this.istPublications
    }
    else {
      const sdate = this.GetStartDate();
      const edate = this.GetEndDate();
      obj.EXPECTED_DATEO = sdate;
      obj.ANALYSIS_END_DATEO = edate;
    }
    return obj;
  }

  SavePublications() {
    if (this.validateControls()) {
      var formData = this.getForm();

      if (formData["EXPECTED_DATE"] != null) {
        const ldate = new Date(formData["EXPECTED_DATE"]);
        formData["STR_EXPECTED_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData["EXPECTED_DATE"] = new Date(formData["EXPECTED_DATE"]);
      }
      if (formData["ANALYSIS_END_DATE"] != null) {
        const ldate = new Date(formData["ANALYSIS_END_DATE"]);
        formData["STR_ANALYSIS_END_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData["ANALYSIS_END_DATE"] = new Date(formData["ANALYSIS_END_DATE"])
      }
      formData["APPLICATION_ID"] = this.ApplicationID;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;
      let title = this.publicationsForm.controls["TITLE"].value;
      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTPublications/Insert", formData).subscribe(result => {
          if (result.Status == 0) {
            this.publicationsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0) 
              {
                this.commonService.SuccessBanner("Publication " + title + " added/submitted  successfully");
                this.modalRef.close();
              }
              else
              {
                this.commonService.ValidationBanner(result.Message);
              }
            });
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/ISTPublications/Update", formData).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES")
          {
            this.publicationsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") 
              {
                if (result.Status == 0 )
                {
                  this.commonService.SuccessBanner("Publication " + title + " details updated successfully");
                  this.modalRef.close();
                }
                else
                {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else
              {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner("Publication " + title + " details updated successfully");
                  this.action.next(formData);
                  this.modalRef.close(formData);
                }
              }
            });
          } 
          else
           {
            this.commonService.ValidationBanner(result.Message);
            // this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
            //   if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
            //     this.commonService.ValidationBanner(result.Message);
            //   }
            //   else {
            //     if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
            //       this.commonService.ValidationBanner(result.Message);
            //     }
            //     else {
            //       this.commonService.SuccessBanner("Publication " + title + " details updated successfully");
            //       this.action.next(formData);
            //       this.modalRef.close(formData);
            //     }
            //   }
            // });
          }
        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.publicationsForm.value;

    if (this.staticformFields?.TYPE_ID.IS_Display && this.staticformFields?.TYPE_ID.IS_MANDATORY) {
      if (formData.TYPE_ID === null || formData.TYPE_ID === "") {
        $("#TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.TYPE_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#TYPE_ID").addClass("ng-untouched ng-valid");
        $("#TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.CONTENT_ID.IS_Display && this.staticformFields?.CONTENT_ID.IS_MANDATORY) {
      if (formData.CONTENT_ID === null || formData.CONTENT_ID === "") {
        $("#CONTENT_ID").addClass("ng-touched ng-invalid validate-error");
        $("#CONTENT_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.CONTENT_ID.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#CONTENT_ID").addClass("ng-untouched ng-valid");
        $("#CONTENT_ID").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.JOURNAL_NAME.IS_Display && this.staticformFields?.JOURNAL_NAME.IS_MANDATORY) {
      if (formData.JOURNAL_NAME === null || formData.JOURNAL_NAME === "") {
        $("#JOURNAL_NAME").addClass("ng-touched ng-invalid validate-error");
        $("#JOURNAL_NAME").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.JOURNAL_NAME.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#JOURNAL_NAME").addClass("ng-untouched ng-valid");
        $("#JOURNAL_NAME").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TITLE.IS_Display && this.staticformFields?.TITLE.IS_MANDATORY) {
      if (formData.TITLE === null || formData.TITLE === "") {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#TITLE").addClass("ng-untouched ng-valid");
        $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.EXPECTED_DATE.IS_Display && this.staticformFields?.EXPECTED_DATE.IS_MANDATORY) {
      if (formData.EXPECTED_DATE === null || formData.EXPECTED_DATE === undefined || formData.EXPECTED_DATE === "") {
        $("#EXPECTED_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#EXPECTED_DATE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.EXPECTED_DATE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#EXPECTED_DATE").addClass("ng-untouched ng-valid");
        $("#EXPECTED_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ANALYSIS_END_DATE.IS_Display && this.staticformFields?.ANALYSIS_END_DATE.IS_MANDATORY) {
      if (formData.ANALYSIS_END_DATE === null || formData.ANALYSIS_END_DATE === undefined || formData.ANALYSIS_END_DATE === "") {
        $("#ANALYSIS_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#ANALYSIS_END_DATE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ANALYSIS_END_DATE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ANALYSIS_END_DATE").addClass("ng-untouched ng-valid");
        $("#ANALYSIS_END_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.NOTES.IS_Display && this.staticformFields?.NOTES.IS_MANDATORY) {
      if (formData.NOTES === null || formData.NOTES === "") {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      message = message + ExtenMsgs; //this.extendedForm.validateControlsMsgs();
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {
    this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + 1).subscribe((result) => {
      this.rowData = result;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 350);
    });
  }

  addNewAttachment() {
    let modalRef = this.modalService.open(AttachmentClassificationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      screencode:"SCR-011",
      is_ac_display:this.staticformFields.Publications_AC.IS_Display,
      is_ac_mand:this.staticformFields.Publications_AC.IS_MANDATORY,
      ac_label:this.staticformFields.Publications_AC.LABEL_NAME,
      is_file_display:this.staticformFields.Publications_CF.IS_Display,
      is_file_mand:this.staticformFields.Publications_CF.IS_MANDATORY,
      file_lable:this.staticformFields.Publications_CF.LABEL_NAME,
      file_subLabel:this.staticformFields.Publications_CF.SUB_LABEL,
      is_multiple_files:this.staticformFields.Publications_CF.IS_MULTISELECT,
      content: { id: "", ModuleName: "IST", ScreenName: 'Publications', filesList: this.rowData }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      result.forEach((item: any) => {
        this.rowData.push(item);
      });
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })

  }

  setOperations(RawData: any): any {
    let tempOperations;
    if (this.Content.heading == 'Edit') {
      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        },
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }

    if (this.Content.heading == 'View') {
      tempOperations = [
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }

    if (this.Content.heading == "Add") {

      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        }
      ];
    }

    this.setDef(tempOperations);
    RawData.forEach(element => {
      if (element.Status == "Add" && this.Content.heading == 'Edit') {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      } else {
        element["Operations"] = this.setDef(tempOperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  Download() {
    var fileID = this['self'].selectedRow['FileID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.previewFile(fileID, fileName, "med");
  }

  Delete() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content = { heading: '', custommessage: 'Are you sure you want to delete the ' + fileName + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
    modalRef.result.then(result => {
      if (result == 'okclick') {
        let index = this['self'].rowData.findIndex(x => x.FileID == fileID);
        if (index != null) {
          this['self'].rowData.splice(index, 1);
          this['self'].loadGrid = false;
          setTimeout(() => {
            this['self'].loadGrid = true;
            document.body.click();
          }, 300);
        }
      }
    });
  }
}
